require('./advisor_header/commands/create_empty_suggested_plan_command.ts');
require('./advisor_header/components/auto_generated_plan_header/auto_generated_plan_header.ts');
require('./advisor_header/components/discard_draft_popup/discard_draft_popup.ts');
require('./advisor_header/components/edit_plan/edit_plan.ts');
require('./advisor_header/components/external_registration_link/commands/external_registration_link_command.ts');
require('./advisor_header/components/external_registration_link/external_registration_link.ts');
require('./advisor_header/components/external_registration_link/models/external_registration_link_model.ts');
require('./advisor_header/components/plan_looks_good/plan_looks_good.ts');
require('./advisor_header/components/student_profiles_listing/models/student_profiles_listing_model.ts');
require('./advisor_header/components/student_profiles_listing/student_profiles_listing.ts');
require('./advisor_header/components/view_plan/view_plan.ts');
require('./alternate_plans/builders/ap_alternate_plan_details_slot_builder.ts');
require('./alternate_plans/builders/ap_alternate_plan_list_item_builder.ts');
require('./alternate_plans/builders/ap_alternate_plan_non_existing_course_builder.ts');
require('./alternate_plans/commands/change_specialization_plan_command.ts');
require('./alternate_plans/commands/get_non_existing_courses_new_plan_command.ts');
require('./alternate_plans/commands/load_alternate_plan_details_command.ts');
require('./alternate_plans/commands/load_alternate_plan_list_command.ts');
require('./alternate_plans/components/alternate_plan_change_plan_popup/alternate_plan_change_plan_popup.ts');
require('./alternate_plans/components/alternate_plan_details/alternate_plan_details.ts');
require('./alternate_plans/components/alternate_plan_header/alternate_plan_header.ts');
require('./alternate_plans/components/alternate_plan_link/alternate_plan_link.ts');
require('./alternate_plans/components/alternate_plan_list/alternate_plan_list.ts');
require('./alternate_plans/components/alternate_plan_list_item/alternate_plan_list_item.ts');
require('./alternate_plans/components/alternate_plans/alternate_plans.ts');
require('./alternate_plans/datasources/alternate_plan_list_datasource.ts');
require('./alternate_plans/datasources/non_existing_courses_new_plan_datasource.ts');
require('./alternate_plans/models/alternate_plan_compare_plans_model.ts');
require('./alternate_plans/queries/alternate_plan_change_plan_popup_details_query.ts');
require('./alternate_plans/queries/alternate_plan_compare_plans_query.ts');
require('./alternate_plans/queries/ap_alternate_plan_list_query.ts');
require('./changelog/builders/ap_changelog_builder.ts');
require('./changelog/commands/load_changelog_command.ts');
require('./changelog/components/changelog/changelog.ts');
require('./changelog/datasources/ap_changelog_datasource.ts');
require('./changelog/queries/ap_changelog_query.ts');
require('./changelog/servants/ap_changelog_servant.ts');
require('./changelog/strategies/ap_changelog_strategy.ts');
require('./comments/builders/comment_builder.ts');
require('./comments/datasources/comments_datasource.ts');
require('./comments/servants/comment_servant.ts');
require('./config/academic_planner_config.ts');
require('./config/data_configuration.ts');
require('./custom_texts/builders/custom_text_builder.ts');
require('./custom_texts/commands/load_custom_text_command.ts');
require('./custom_texts/datasources/custom_text_datasource.ts');
require('./custom_texts/queries/custom_text_query.ts');
require('./global/builders/ap_available_term_builder.ts');
require('./global/builders/ap_course_builder.ts');
require('./global/builders/ap_course_group_builder.ts');
require('./global/builders/ap_generic_slot_builder.ts');
require('./global/builders/ap_goal_sets_builder.ts');
require('./global/builders/ap_goals_builder.ts');
require('./global/builders/ap_gradeconfig_builder.ts');
require('./global/builders/ap_mm_favorite_course_builder.ts');
require('./global/builders/ap_multi_template_dev_req_slot_builder.ts');
require('./global/builders/ap_multi_template_slot_builder.ts');
require('./global/builders/ap_multi_term_builder.ts');
require('./global/builders/ap_planned_course_builder.ts');
require('./global/builders/ap_program_info_builder.ts');
require('./global/builders/ap_program_slot_builder.ts');
require('./global/builders/ap_section_type_builder.ts');
require('./global/builders/ap_term_builder.ts');
require('./global/builders/ap_term_slot_group_builder.ts');
require('./global/builders/ap_year_slot_group_builder.ts');
require('./global/builders/planned_course_builder.ts');
require('./global/builders/planned_course_group_builder.ts');
require('./global/builders/planned_term_builder.ts');
require('./global/commands/initialize_user_activity_tracking_command.ts');
require('./global/commands/load_academic_plan_command.ts');
require('./global/commands/load_ap_for_advisor_command.ts');
require('./global/commands/load_ap_gradeconfigs_command.ts');
require('./global/commands/load_available_terms_command.ts');
require('./global/commands/load_favorite_courses_command.ts');
require('./global/commands/load_goal_sets_command.ts');
require('./global/commands/load_goals_command.ts');
require('./global/commands/load_mm_degree_map_command.ts');
require('./global/commands/load_mm_favorite_courses_command.ts');
require('./global/commands/load_multi_academic_plan_command.ts');
require('./global/commands/setup_user_command.ts');
require('./global/components/busy_indicator/busy_indicator_srv.ts');
require('./global/components/busy_indicator/components/busy_indicator.ts');
require('./global/components/course_detail/commands/clear_course_info_command.ts');
require('./global/components/course_detail/commands/load_course_info_command.ts');
require('./global/components/course_detail/commands/load_mm_course_info_command.ts');
require('./global/components/course_detail/commands/save_favorite_course_command.ts');
require('./global/components/course_detail/commands/unsave_favorite_course_command.ts');
require('./global/components/course_detail/course_detail.ts');
require('./global/components/course_detail/facades/course_group_course_detail_open_facade.ts');
require('./global/components/course_detail/mm_course_details.ts');
require('./global/components/course_detail/models/course_info_model.ts');
require('./global/components/course_detail/queries/ap_course_info_query.ts');
require('./global/components/course_detail/servants/course_req_servant.ts');
require('./global/components/course_detail/servants/course_req_tree.ts');
require('./global/components/course_flag_dialog/commands/create_course_flag_command.ts');
require('./global/components/course_flag_dialog/commands/load_course_flag_command.ts');
require('./global/components/course_flag_dialog/commands/remove_course_flag_command.ts');
require('./global/components/course_flag_dialog/commands/update_course_flag_command.ts');
require('./global/components/course_flag_dialog/course_flag_dialog.ts');
require('./global/components/course_flag_dialog/strategies/course_flag_content_type_strategy.ts');
require('./global/components/course_group_button/commands/remove_course_from_term_and_add_course_group_command.ts');
require('./global/components/course_group_button/commands/remove_course_group_from_term_and_add_course_command.ts');
require('./global/components/course_group_button/course_group_button.ts');
require('./global/components/course_group_course_list/course_group_course_list.ts');
require('./global/components/course_group_tile/course_group_mm_tile.ts');
require('./global/components/course_group_tile/course_group_tile.ts');
require('./global/components/course_lock_dialog/commands/course_toggle_lock_comand.ts');
require('./global/components/course_lock_dialog/course_lock_dialog.ts');
require('./global/components/course_placeholder_menu/course_placeholder_menu.ts');
require('./global/components/course_status_badge/course_status_badge.ts');
require('./global/components/course_tile_component/course_tile_component.ts');
require('./global/components/course_tile_component/course_tile_mm_component.ts');
require('./global/components/course_tile_component_container/course_tile_component_container.ts');
require('./global/components/course_tile_menu/course_tile_course_menu.ts');
require('./global/components/course_tile_menu/course_tile_group_menu.ts');
require('./global/components/course_tile_menu/course_tile_menu.ts');
require('./global/components/degree_title/degree_title.ts');
require('./global/components/goal_sets_title/goal_sets_title.ts');
require('./global/components/mark_as_met/builders/mark_as_met_status_builder.ts');
require('./global/components/mark_as_met/commands/load_mark_as_met_list_command.ts');
require('./global/components/mark_as_met/commands/mark_as_met_slot_command.ts');
require('./global/components/mark_as_met/commands/set_mark_as_met_slot_command.ts');
require('./global/components/mark_as_met/components/dialog/mark_as_met_dialog.ts');
require('./global/components/mark_as_met/datasources/mark_as_met_status_datasource.ts');
require('./global/components/mark_as_met/facades/mark_as_met_facade.ts');
require('./global/components/mark_as_met/models/mark_as_met_slot_model.ts');
require('./global/components/mark_as_met/queries/mark_as_met_dialog_query.ts');
require('./global/components/mark_as_met/stratgies/mark_as_met_slot_command_param_strategy.ts');
require('./global/components/mark_as_met/stratgies/mark_as_met_unmet_url_strategy.ts');
require('./global/components/mark_as_unmet/command/delete_mark_as_met_entry_command.ts');
require('./global/components/mark_as_unmet/components/mark_as_unmet_dialog/mark_as_unmet_dialog.ts');
require('./global/components/ncr_menu/ncr_menu.ts');
require('./global/components/ncr_tile/ncr_tile.ts');
require('./global/components/popup_component/popup_component.ts');
require('./global/components/remove_class_on_leave/remove_class_on_leave.ts');
require('./global/components/scheduled_course_tile_circle/scheduled_course_tile_circle.ts');
require('./global/components/student_details/commands/ap_load_student_details_command.ts');
require('./global/components/student_details/models/ap_student_details_model.ts');
require('./global/components/student_details/queries/student_details_query.ts');
require('./global/components/student_plan_progress/student_plan_progress.ts');
require('./global/components/student_value/commands/delete_student_value_command.ts');
require('./global/components/student_value/commands/load_student_value_command.ts');
require('./global/components/student_value/model/student_value_model.ts');
require('./global/components/user_mode_config/config/ap_user_mode_config.ts');
require('./global/components/wildcard_menu/wildcard_menu.ts');
require('./global/components/wildcard_tile/wildcard_tile.ts');
require('./global/constants/ap_id_constants.ts');
require('./global/datasources/ap_available_terms_datasource.ts');
require('./global/datasources/ap_courses_datasource.ts');
require('./global/datasources/ap_goal_sets_datasource.ts');
require('./global/datasources/ap_goals_datasource.ts');
require('./global/datasources/ap_gradeconfigs_datasource.ts');
require('./global/datasources/ap_mm_favorite_course_datasource.ts');
require('./global/datasources/ap_multi_student_term_datasource.ts');
require('./global/datasources/ap_multi_template_slot_dataSource.ts');
require('./global/datasources/ap_multi_templatedev_req_slot_dataSource.ts');
require('./global/datasources/ap_planned_course_datasource.ts');
require('./global/datasources/ap_planned_course_group_datasource.ts');
require('./global/datasources/ap_program_info_datasource.ts');
require('./global/datasources/ap_program_slot_datasource.ts');
require('./global/datasources/ap_section_type_datasource.ts');
require('./global/datasources/ap_term_slot_group_datasource.ts');
require('./global/datasources/ap_terms_datasource.ts');
require('./global/datasources/ap_year_slot_group_datasource.ts');
require('./global/directives/add_attr_after/add_attr_after.ts');
require('./global/helpers/ap_multi_plan_helper.ts');
require('./global/helpers/notification_delegate.ts');
require('./global/helpers/program_slot_helper.ts');
require('./global/helpers/router_helper.ts');
require('./global/helpers/update_plan_data_helper.ts');
require('./global/models/ap_component_state_model.ts');
require('./global/models/ap_model.ts');
require('./global/servants/ap_advisor_text_servant.ts');
require('./global/servants/ap_command_url_servant.ts');
require('./global/servants/ap_course_group_payload_servant.ts');
require('./global/servants/ap_course_servant.ts');
require('./global/servants/ap_generic_slot_servant.ts');
require('./global/servants/ap_planned_course_servant.ts');
require('./global/servants/ap_program_slot_servant.ts');
require('./global/servants/ap_section_type_servant.ts');
require('./global/servants/ap_term_servant.ts');
require('./global/strategies/ap_advisor_init_redirect_strategy.ts');
require('./global/strategies/ap_api_url_strategy.ts');
require('./global/strategies/ap_command_url_strategy.ts');
require('./global/strategies/ap_course_requisite_reminder_strategy.ts');
require('./global/strategies/ap_course_status_strategy.ts');
require('./global/strategies/ap_term_course_status_group_strategy.ts');
require('./global/strategies/ap_term_status_strategy.ts');
require('./global/strategies/user_mode_api_strategy.ts');
require('./global/types/common_types.ts');
require('./global/types/course_conflict_enum.ts');
require('./global/types/course_developmental_enum.ts');
require('./global/types/course_key_enum.ts');
require('./global/types/developmental_enum.ts');
require('./global/types/term_status_enum.ts');
require('./global/validators/ap_validator.ts');
require('./global/validators/verify_academic_plan_data.ts');
require('./plan/commands/add_mm_term_command.ts');
require('./plan/commands/add_term_command.ts');
require('./plan/commands/advisor_add_course_group_command.ts');
require('./plan/commands/bulk_lock_unlock_courses_command.ts');
require('./plan/commands/delete_mm_term_command.ts');
require('./plan/commands/delete_term_command.ts');
require('./plan/commands/remove_course_from_term_and_add_course_command.ts');
require('./plan/commands/remove_course_from_term_command.ts');
require('./plan/commands/remove_course_group_from_term_and_add_course_group_command.ts');
require('./plan/commands/remove_course_group_from_term_command.ts');
require('./plan/commands/remove_mm_course_from_term_command.ts');
require('./plan/commands/remove_mm_course_group_from_term_command.ts');
require('./plan/commands/save_course_group_to_term_command.ts');
require('./plan/commands/save_course_to_term_command.ts');
require('./plan/commands/save_mm_course_group_to_term_command.ts');
require('./plan/commands/save_mm_course_to_term_command.ts');
require('./plan/commands/student_add_course_group_command.ts');
require('./plan/commands/update_program_slot_command.ts');
require('./plan/components/bulk_courses_lock_unlock_modal/bulk_courses_lock_unlock_modal.ts');
require('./plan/components/conflict_reminder_popup/conflict_reminder_popup.ts');
require('./plan/components/course_slot_component/course_detail_component/course_detail_component.ts');
require('./plan/components/course_slot_component/course_slot_component.ts');
require('./plan/components/degree_map/components/degree_map_instructions_component/degree_map_instructions_component.ts');
require('./plan/components/degree_map/components/degree_map_instructions_component/mm_degree_map_instructions_component.ts');
require('./plan/components/degree_map/components/degree_map_instructions_component/models/degree_map_instructions_component_state_model.ts');
require('./plan/components/degree_map/components/degree_map_slot_group_component/degree_map_slot_group_component.ts');
require('./plan/components/degree_map/components/degree_map_slot_group_component/multiple_degree_map_slot_group_component.ts');
require('./plan/components/degree_map/degree_map.ts');
require('./plan/components/degree_map/multi_degree_map.ts');
require('./plan/components/degree_map/queries/ap_degree_map_query.ts');
require('./plan/components/degree_map/queries/ap_multi_degree_template_query.ts');
require('./plan/components/favorite/ap_mm_favorite_courses.ts');
require('./plan/components/favorite/favorite.ts');
require('./plan/components/large_course_group/commands/clear_large_course_group_search_result_model.ts');
require('./plan/components/large_course_group/commands/fetch_large_course_group_command.ts');
require('./plan/components/large_course_group/commands/hide_large_course_group_command.ts');
require('./plan/components/large_course_group/commands/show_large_course_group_command.ts');
require('./plan/components/large_course_group/large_course_group.ts');
require('./plan/components/large_course_group/models/large_course_group_model.ts');
require('./plan/components/large_course_group/models/large_course_group_search_result_model.ts');
require('./plan/components/large_course_group/queries/large_course_group_search_results_query.ts');
require('./plan/components/no_plan_configured/no_plan_configured.ts');
require('./plan/components/planner/multi_major/multi_major_planner.ts');
require('./plan/components/planner/planner.ts');
require('./plan/components/planner_add_term_menu/planner_add_term_menu.ts');
require('./plan/components/planner_add_term_menu/planner_mm_add_term_menu.ts');
require('./plan/components/planner_course_delete_area/planner_course_delete_area.ts');
require('./plan/components/planner_legends/planner_legends.ts');
require('./plan/components/planner_resources/builders/planner_resource_tab_builder.ts');
require('./plan/components/planner_resources/commands/set_selected_planner_resource_tab_command.ts');
require('./plan/components/planner_resources/constants/planner_resource_tabs.ts');
require('./plan/components/planner_resources/models/selected_planner_resource_tab_model.ts');
require('./plan/components/planner_resources/multi_planner_resources.ts');
require('./plan/components/planner_resources/planner_resources.ts');
require('./plan/components/planner_resources/queries/planner_resource_tabs_query.ts');
require('./plan/components/planner_search/course_search/builders/ap_course_search_builder.ts');
require('./plan/components/planner_search/course_search/commands/ap_course_search_clear_command.ts');
require('./plan/components/planner_search/course_search/commands/ap_course_search_command.ts');
require('./plan/components/planner_search/course_search/datasources/ap_course_search_datasource.ts');
require('./plan/components/planner_search/course_search/queries/ap_course_search_query.ts');
require('./plan/components/planner_search/search_course.ts');
require('./plan/components/planner_terms/planner_mm_terms.ts');
require('./plan/components/planner_terms/planner_terms.ts');
require('./plan/components/slot_status_badge/servants/slot_status_badge_html_servant.ts');
require('./plan/components/slot_status_badge/slot_status_badge.ts');
require('./plan/components/student_plan_comparison/student_plan_comparison.ts');
require('./plan/components/term_box/term_box.ts');
require('./plan/components/term_box/term_box_mm.ts');
require('./plan/components/term_box_button/term_box_button.ts');
require('./plan/components/term_box_countdown_timer/term_box_countdown_timer.ts');
require('./plan/components/term_box_menu/term_box_menu.ts');
require('./plan/components/term_box_menu/term_box_mm_menu.ts');
require('./plan/components/term_delete/term_delete.ts');
require('./plan/components/term_delete/term_mm_delete_dialog.ts');
require('./plan/components/term_registration_status/term_registration_status.ts');
require('./plan/constants/event_names.ts');
require('./plan/queries/ap_available_terms_query.ts');
require('./plan/queries/ap_degree_map_query_helper.ts');
require('./plan/queries/ap_favorite_courses_query.ts');
require('./plan/queries/ap_goal_sets_query.ts');
require('./plan/queries/ap_goals_query.ts');
require('./plan/queries/ap_mm_favorite_courses_query.ts');
require('./plan/queries/ap_mm_terms_query.ts');
require('./plan/queries/ap_past_terms_query.ts');
require('./plan/queries/ap_planned_course_group_query.ts');
require('./plan/queries/ap_planned_course_query.ts');
require('./plan/queries/ap_program_details_query.ts');
require('./plan/queries/ap_program_info_query.ts');
require('./plan/queries/ap_program_slot_query.ts');
require('./plan/queries/ap_term_course_data_query_helper.ts');
require('./plan/queries/ap_terms_query.ts');
require('./plan/relationship/ap_courses_terms_relationship.ts');
require('./planner_app.ts');
require('./preferences/components/intake_survey/builders/ap_intake_survey_answer_builder.ts');
require('./preferences/components/intake_survey/builders/ap_intake_survey_builder.ts');
require('./preferences/components/intake_survey/builders/ap_intake_survey_question_choice_builder.ts');
require('./preferences/components/intake_survey/commands/get_estimated_graduation_time_command.ts');
require('./preferences/components/intake_survey/commands/load_ap_intake_survey_answer_command.ts');
require('./preferences/components/intake_survey/commands/load_ap_intake_survey_poll_command.ts');
require('./preferences/components/intake_survey/commands/save_ap_intake_survey_answer_command.ts');
require('./preferences/components/intake_survey/commands/save_multiple_question_answer_command.ts');
require('./preferences/components/intake_survey/constants/intake_survey_constants.ts');
require('./preferences/components/intake_survey/datasources/intake_survey_answers_datasource.ts');
require('./preferences/components/intake_survey/datasources/intake_survey_choices_datasource.ts');
require('./preferences/components/intake_survey/datasources/intake_survey_questions_datasource.ts');
require('./preferences/components/intake_survey/queries/get_intake_survey_questions_query.ts');
require('./preferences/components/intake_survey/servants/poll_servant.ts');
require('./preferences/components/intake_survey/strategies/ap_intake_survey_answer_strategy.ts');
require('./preferences/components/intake_survey/strategies/ap_intake_survey_default_answer_strategy.ts');
require('./preferences/components/intake_survey/strategies/intake_survey_answer_strategy.ts');
require('./preferences/components/intake_survey/strategies/intake_survey_api_ques_ans_strategy.ts');
require('./preferences/components/intake_survey/strategies/question_type_input_type_strategy.ts');
require('./preferences/components/preview_plan/commands/clear_term_preview_plan_command.ts');
require('./preferences/components/preview_plan/commands/completed_auto_generated_preview_plan_showing_command.ts');
require('./preferences/components/preview_plan/commands/create_empty_terms_command.ts');
require('./preferences/components/preview_plan/commands/load_term_preview_plan_command.ts');
require('./preferences/components/preview_plan/commands/save_term_preview_plan_command.ts');
require('./preferences/components/preview_plan/components/checkbox_question_component/checkbox_question_component.ts');
require('./preferences/components/preview_plan/components/preview_auto_generated_terms/preview_auto_generated_terms.ts');
require('./preferences/components/preview_plan/components/preview_auto_generated_terms_header/preview_auto_generated_terms_header.ts');
require('./preferences/components/preview_plan/components/preview_plan_auto_generated_failure/preview_plan_auto_generated_failure.ts');
require('./preferences/components/preview_plan/components/preview_term_box/preview_term_box.ts');
require('./preferences/components/preview_plan/components/preview_term_dummy_box/preview_term_dummy_box.ts');
require('./preferences/components/preview_plan/components/preview_term_plan_course_group_tile/preview_term_plan_course_group_tile.ts');
require('./preferences/components/preview_plan/components/preview_term_plan_course_tile/preview_term_plan_course_tile.ts');
require('./preferences/components/preview_plan/components/preview_term_plan_estimated_graduation_time/preview_term_plan_estimated_graduation_time.ts');
require('./preferences/components/preview_plan/components/preview_term_plan_legends/preview_term_plan_dev_req_legend/preview_term_plan_dev_req_legend.ts');
require('./preferences/components/preview_plan/components/preview_term_plan_legends/preview_term_plan_legends.ts');
require('./preferences/components/preview_plan/components/preview_terms_plan/preview_terms_plan.ts');
require('./preferences/components/preview_plan/components/preview_terms_plan_header/preview_terms_plan_header.ts');
require('./preferences/components/preview_plan/components/preview_terms_plan_header/servants/ap_preview_plan_servant.ts');
require('./preferences/components/preview_plan/components/radio_question_component/radio_question_component.ts');
require('./preferences/components/preview_plan/components/save_generated_term_button/save_generated_term_button.ts');
require('./preferences/components/preview_plan/constants/preview_term_plan_constants.ts');
require('./preferences/components/preview_plan/helpers/intake_survey_nk_helper.ts');
require('./preferences/components/preview_plan/models/preview_term_plan_model.ts');
require('./preferences/components/preview_plan/queries/preview_term_plan_query.ts');
require('./preferences/components/preview_plan/validators/verify_preview_plan_data.ts');
require('./routes/advisor_routes/ap_advisor_alternate_plans_routes.ts');
require('./routes/advisor_routes/ap_advisor_changelog_routes.ts');
require('./routes/advisor_routes/ap_advisor_course_detail_routes.ts');
require('./routes/advisor_routes/ap_advisor_plan_routes.ts');
require('./routes/advisor_routes/ap_advisor_preview_plan_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_flag_course_popup_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_lock_course_popup_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_mark_as_met_popup_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_planner_edit_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_planner_view_routes.ts');
require('./routes/advisor_routes/planner/ap_advisor_suggestion_blocked_state_routes.ts');
require('./routes/ap_alternate_plan_routes.ts');
require('./routes/ap_changelog_routes.ts');
require('./routes/ap_course_details_routes.ts');
require('./routes/ap_default_root_routes.ts');
require('./routes/ap_plan_feedback_routes.ts');
require('./routes/ap_plan_routes.ts');
require('./routes/ap_preview_plan_routes.ts');
require('./routes/ap_smart_catalog_routes.ts');
require('./routes/mark_as_met_unmet_routes.ts');
require('./routes/re_route_strategies/navigate_if_plan_blocked_command.ts');
require('./routes/re_route_strategies/prevent_access_to_advisor_auto_generated_plan_command.ts');
require('./routes/re_route_strategies/prevent_access_to_planner_command.ts');
require('./routes/re_route_strategies/re_route_advisor_plan_access_command.ts');
require('./routes/re_route_strategies/prevent_access_and_redirect_to_ap3_command.ts');
require('./smart_catalog/builders/ap_scl_options_item_builder.ts');
require('./smart_catalog/commands/cached_scl_search_config_command.ts');
require('./smart_catalog/commands/load_scl_search_config_command.ts');
require('./smart_catalog/components/course_details_menu/course_details_menu.ts');
require('./smart_catalog/components/course_details_menu/mm_course_details_menu.ts');
require('./smart_catalog/components/scl_add_to_term_dialog/scl_add_to_term_dialog.ts');
require('./smart_catalog/components/smart_search/smart_catalog_search.ts');
require('./smart_catalog/configuration/large_course_group_smart_search/large_course_group_smart_search_configuration.ts');
require('./smart_catalog/configuration/plugins/smart_search_plugins.ts');
require('./smart_catalog/configuration/search_prefab_configuration.ts');
require('./smart_catalog/configuration/sgd_metadata.ts');
require('./smart_catalog/configuration/smart_catalog_module_config.ts');
require('./smart_catalog/datasources/scl_options_datasource.ts');
require('./smart_catalog/helpers/cookie_reader_helper.ts');
require('./smart_catalog/helpers/smart_search_request_response_headers_helper.ts');
require('./smart_catalog/models/cache_scl_search_config_command_model.ts');
require('./smart_catalog/servants/ap_smart_search_servant.ts');
require('./smart_catalog/types/smart_search_user_modes.ts');
require('./suggestions/commands/commit_suggested_plan_command.ts');
require('./suggestions/commands/load_program_and_terms_data_command.ts');
require('./suggestions/components/blocked_suggestions/commands/load_blocked_suggestions_command.ts');
require('./suggestions/components/blocked_suggestions/commands/perform_action_on_blocked_suggestions_command.ts');
require('./suggestions/components/blocked_suggestions/components/back_to_blocked_suggestions/back_to_blocked_suggestions.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_acceptable_suggestions/blocked_acceptable_suggestions.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_conflicting_suggestions/blocked_conflicting_suggestions.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_header/blocked_header.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_suggested_plan_large_course_group/blocked_suggested_plan_large_course_group.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_suggestion_fixed_footer/blocked_suggestion_fixed_footer.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_suggestions/blocked_suggestions.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_suggestions_listing/blocked_suggestions_listing.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_suggestions_suggested_plan/blocked_suggestions_suggested_plan.ts');
require('./suggestions/components/blocked_suggestions/components/blocked_view_suggested_plan/blocked_view_suggested_plan.ts');
require('./suggestions/components/blocked_suggestions/models/conflicting_suggestions_model.ts');
require('./suggestions/components/blocked_suggestions/queries/blocked_suggestions_query.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_course_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_course_group_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_generic_slot_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_program_slot_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_term_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_transaction_builder.ts');
require('./suggestions/components/plan_feedback/builders/plan_feedback_transaction_type.ts');
require('./suggestions/components/plan_feedback/commands/accept_decline_plan_feedback_command.ts');
require('./suggestions/components/plan_feedback/commands/change_suggested_plan_status_command.ts');
require('./suggestions/components/plan_feedback/commands/delete_suggested_plan_command.ts');
require('./suggestions/components/plan_feedback/commands/drop_and_create_suggested_plan_command.ts');
require('./suggestions/components/plan_feedback/commands/load_advisor_suggested_plan_command.ts');
require('./suggestions/components/plan_feedback/commands/load_plan_feedback_command.ts');
require('./suggestions/components/plan_feedback/commands/load_suggested_plan_status_command.ts');
require('./suggestions/components/plan_feedback/commands/set_selected_linked_suggestion_command.ts');
require('./suggestions/components/plan_feedback/components/linked_suggestions_action_popup/linked_suggestions_action_popup.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_accept_reject/plan_feedback_accept_reject.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_accepted_all_popup/plan_feedback_accepted_all_popup.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_comments/models/ap_comments_model.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_comments/plan_feedback_comments.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_go_back_popup/plan_feedback_go_back_popup.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_header/plan_feedback_header.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_revoked_popup/plan_feedback_revoked_popup.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_suggestions/plan_feedback_suggestions.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_template_changes/plan_feedback_template_changes.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_template_changes_container/plan_feedback_template_changes_container.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_term/plan_feedback_term.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_term_container/plan_feedback_term_container.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_term_course_group_tile/plan_feedback_term_course_group_tile.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_term_course_tile/plan_feedback_term_course_tile.ts');
require('./suggestions/components/plan_feedback/components/plan_feedback_term_program_slot_tile/plan_feedback_term_program_slot_tile.ts');
require('./suggestions/components/plan_feedback/datasources/plan_feedback_course_groups_datasource.ts');
require('./suggestions/components/plan_feedback/datasources/plan_feedback_courses_datasource.ts');
require('./suggestions/components/plan_feedback/datasources/plan_feedback_program_slots_datasource.ts');
require('./suggestions/components/plan_feedback/datasources/plan_feedback_terms_datasource.ts');
require('./suggestions/components/plan_feedback/helpers/accept_decline_revoke_helper.ts');
require('./suggestions/components/plan_feedback/helpers/perform_action_on_feedback_helper.ts');
require('./suggestions/components/plan_feedback/models/feedback_selected_linked_suggestion_model.ts');
require('./suggestions/components/plan_feedback/models/feedback_suggested_plan_model.ts');
require('./suggestions/components/plan_feedback/plan_feedback.ts');
require('./suggestions/components/plan_feedback/queries/advisor_compare_query.ts');
require('./suggestions/components/plan_feedback/queries/advisor_plan_details_query.ts');
require('./suggestions/components/plan_feedback/queries/advisor_sent_feedback_diff_query.ts');
require('./suggestions/components/plan_feedback/queries/advisor_sent_feedback_graduation_time_query.ts');
require('./suggestions/components/plan_feedback/queries/advisor_sent_feedback_terms_query.ts');
require('./suggestions/components/plan_feedback/queries/feedback_linked_suggestions_query.ts');
require('./suggestions/components/plan_feedback/servants/plan_feedback_servant.ts');
require('./suggestions/components/plan_feedback/strategies/action_message_string_strategy.ts');
require('./suggestions/components/plan_feedback/strategies/plan_feedback_highlight_event_name_strategy.ts');
require('./suggestions/components/plan_feedback/strategies/plan_feedback_transaction_text.ts');
require('./suggestions/components/plan_feedback/strategies/plan_feedback_transaction_types_query_strategy.ts');
require('./suggestions/components/suggestion_comment_dialog/suggestion_comment_dialog.ts');
require('./suggestions/queries/suggested_plan_query.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/core.ts